import { ERROR_MESSAGE_REQUIRED } from '../../config'
import { useUser } from '../../contexts/userContext'
import FormSlide from '../FormSlide'

export default function YourSocialsSlide (props) {
  const { user } = useUser()

  const formData = [
    {
      text: "What's your Linkedin profile? (optional)",
      label: 'linkedinUrl',
      placeholder: 'https://www.linkedin.com/in/owl/',
      type: 'text-box'
    },
    {
      text: "What's your Twitter handle? (optional)",
      label: 'twitterHandle',
      placeholder: '@indexcoop',
      type: 'text-box'
    },
    {
      text: 'Subscribe to our weekly newsletter',
      label: 'isNewsletterSubscribed',
      placeholder: '',
      type: 'switch'
      // defaultChecked: true
    }
  ]

  // Ask for email if not already collected (i.e. auth via wallet)
  if (!user?.email) {
    formData.splice(formData.length - 1, 0, {
      text: "What's your email?",
      label: 'email',
      placeholder: 'Email',
      type: 'email-text-box',
      errorHandling: { required: ERROR_MESSAGE_REQUIRED }
    })
  }

  return (
    <FormSlide
      id='your-socials'
      title='Connecting on Social'
      stageName='Finding your place at Aragon'
      description='We would love to connect with you on social platforms. These can also help us better understand your interests and experience so that we can help connect you with an appropriate working group.'
      formData={formData}
      {...props}
    />
  )
}
